export const templates = [
    {
        id: 1,
        name: "blank",
        image: "blank-poster.jpg",
        formType: 0,
        title: "Blank",
        description: "Create your custom form.",
        elements: [],
        design:{    
            layout: {
                labelStyle: "inline", // inline | block
                textAlign: "center", // left | center | right
                borderRadius: 0,
                fieldBorderRadius: 0 
            },
            backgrounds: {
                color: "#EEF2F5",
                inputColor: "#DDE3EF"
            },
            fonts: {
                title: {
                    font:{
                        name:"rubik-bold"
                    },
                    size: 32,
                    color: "#1B3444"
                },
                label: {
                    font:{
                        name:"rubik-light"
                    },
                    size: 22,
                    color: "#666666"
                },
                input: {
                    font:{
                        name:"rubik-light"
                    },
                    size: 20,
                    color: "#666666"
                },
                button: {
                    font:{
                        name:"rubik-bold"
                    },
                    size: 30,
                    color: "#FFFFFF"
                }
            },
            submit:{
                alignment: "center", // left | center | right
                bgColor: "#5DADDE",
                borderRadius: 5        
            }
        }
    },
    {
        id: 2,
        name: "contact-us",
        image: "contact-us-poster.jpg",
        formType: 1,
        title: "Contact Us",
        description: "Make it easy for people to reach you 24/7.",
        elements:[
            {
                id: 1,
                name: "input",
                label: "Full Name",
                value: "",
                default: "Full Name",
                isHalf: true,
                canBeHalf: true,
                isRequired: true,
                hasOptions: false
            },
            {
                id: 2,
                name: "input",
                label: "Email",
                value: "",
                default: "Email",
                isHalf: true,
                canBeHalf: true,
                isRequired: true,
                hasOptions: false
            },
            {
                id: 3,
                name: "dropdown",
                label: "Subject",
                value: "",
                default: "Subject",
                isHalf: false,
                canBeHalf: true,
                isRequired: false,
                hasOptions: true,
                options: [
                    {
                        id: 1,
                        checked: false,
                        value: "Event"
                    },
                    {
                        id: 2,
                        checked: false,
                        value: "Technical"
                    },
                    {
                        id: 3,
                        checked: false,
                        value: "Custom"
                    }
                ]
            },
            {
                id: 4,
                name: "textaria",
                label: "Comments/Questions",
                value: "",
                default: "",
                isHalf: false,
                isRequired: false,
                canBeHalf: true,
                hasOptions: false
            }
        ],
        design:{    
            layout: {
                labelStyle: "inline", // inline | block
                textAlign: "center", // left | center | right
                borderRadius: 0,
                fieldBorderRadius: 0 
            },
            backgrounds: {
                color: "#EEF2F5",
                inputColor: "#DDE3EF"
            },
            fonts: {
                title: {
                    font:{
                        name:"rubik-bold"
                    },
                    size: 32,
                    color: "#1B3444"
                },
                label: {
                    font:{
                        name:"rubik-light"
                    },
                    size: 22,
                    color: "#666666"
                },
                input: {
                    font:{
                        name:"rubik-light"
                    },
                    size: 20,
                    color: "#666666"
                },
                button: {
                    font:{
                        name:"rubik-bold"
                    },
                    size: 30,
                    color: "#FFFFFF"
                }
            },
            submit:{
                alignment: "center", // left | center | right
                bgColor: "#5DADDE",
                borderRadius: 5        
            }
        }
    },
    {
        id: 3,
        name: "rsvp-event",
        image: "rsvp-event-poster.jpg",
        formType: 2,
        title: "RSVP",
        description: "Set up your event registration form without ticket.",
        elements: [
            {
                id: 1,
                name: "input",
                label: "First Name",
                value: "",
                default: "First Name",
                isHalf: true,
                canBeHalf: true,
                isRequired: true,
                hasOptions: false
            },
            {
                id: 2,
                name: "input",
                label: "Last Name",
                value: "",
                default: "Last Name",
                isHalf: true,
                canBeHalf: true,
                isRequired: true,
                hasOptions: false
            },
            {
                id: 3,
                name: "input",
                label: "Email",
                value: "",
                default: "Email",
                isHalf: false,
                canBeHalf: true,
                isRequired: false,
                hasOptions: false
            },
            {
                id: 4,
                name: "radio",                
                label: "Attending",
                value: "",
                default: "-- Choose item --",
                isHalf: false,
                canBeHalf: true,
                isRequired: false,
                hasOptions: true,
                options: [
                    {
                        id: 1,
                        checked: false,
                        value: "Yes"
                    },
                    {
                        id: 2,
                        checked: false,
                        value: "No"
                    }
                ]
            },
            {
                id: 5,
                name: "counter",
                label: "No. of people",
                value: 3,
                default: 0,
                isHalf: false,
                canBeHalf: true,
                isRequired: false,
                hasOptions: false        
            }
        ],
        design:{    
            layout: {
                labelStyle: "inline", // inline | block
                textAlign: "left", // left | center | right
                borderRadius: 0,
                fieldBorderRadius: 0 
            },
            backgrounds: {
                color: "#EBEBEB",
                inputColor: "#565656"
            },
            fonts: {
                title: {
                    font:{
                        name:"inconsolata-bold"
                    },
                    size: 24,
                    color: "#565656"
                },
                label: {
                    font:{
                        name:"inconsolata"
                    },
                    size: 20,
                    color: "#565656"
                },
                input: {
                    font:{
                        name:"inconsolata"
                    },
                    size: 18,
                    color: "#ffffff"
                },
                button: {
                    font:{
                        name:"inconsolata"
                    },
                    size: 24,
                    color: "#FFFFFF"
                }
            },
            submit:{
                alignment: "right", // left | center | right
                bgColor: "#505050",
                borderRadius: 5        
            }
        }
    },
    {
        id: 4,
        name: "subscribe",
        image: "subscribe-poster.jpg",
        formType: 3,
        title: "SUBSCRIBE TO OUR MAILING LIST",
        description: "Grow your mailing list with a customizable subscription form. Add fields, change the design and more.",
        elements: [
            {
                id: 1,
                name: "input",
                label: "First Name",
                value: "",
                default: "First Name",
                isHalf: true,
                canBeHalf: true,
                isRequired: true,
                hasOptions: false
            },
            {
                id: 2,
                name: "input",
                label: "Last Name",
                value: "",
                default: "Last Name",
                isHalf: true,
                canBeHalf: true,
                isRequired: true,
                hasOptions: false
            },
            {
                id: 3,
                name: "input",
                label: "Email",
                value: "",
                default: "Email",
                isHalf: false,
                canBeHalf: true,
                isRequired: true,
                hasOptions: false
            }
        ],
        design:{    
            layout: {
                labelStyle: "inline", // inline | block
                textAlign: "center", // left | center | right
                borderRadius: 0,
                fieldBorderRadius: 0 
            },
            backgrounds: {
                color: "#ffffff",
                inputColor: "#ffffff"
            },
            fonts: {
                title: {
                    font:{
                        name:"opensans"
                    },
                    size: 32,
                    color: "#000000"
                },
                label: {
                    font:{
                        name:"opensans"
                    },
                    size: 22,
                    color: "#000000"
                },
                input: {
                    font:{
                        name:"opensans"
                    },
                    size: 20,
                    color: "#000000"
                },
                button: {
                    font:{
                        name:"opensans"
                    },
                    size: 30,
                    color: "#ffffff"
                }
            },
            submit:{
                alignment: "right", // left | center | right
                bgColor: "#4a90e2",
                borderRadius: 10        
            }
        }
    }
]



export const tabButtons = [
    {
        //id: 2,
        id: 1,
        name: "templates",
        title: "templates",
        is_preview: false,
        is_disabled: true,
        is_hidden: false,
    },
    {
        //id:3,
        id: 2,
        name: "edit",
        title: "edit",
        is_preview: false,
        is_disabled: true,
        is_hidden: false,

    },
    {
        //id:4,
        id: 3,
        name: "design",
        title: "design",
        is_preview: false,
        is_disabled: true,
        is_hidden: false,

    },    
    {
        //id:1,
        id: 4,
        name: "settings",
        title: "settings",
        is_preview: false,
        is_disabled: true,
        is_hidden: false,

    },
    {
        id:5,
        name: "preview", // actually means submissions data
        title: "submissions data",
        is_preview: true
    }
]